<template>
  <div>
    <Breadcrumbs :title="$t('lbl_EMPBE_Report')" />
    <visitorPermission>
      <template v-slot:body>
        <div class="font-roboto report-container">
          <div class="card">
              <Report :IsStrus="1"/>
          </div>
        </div>
      </template>
    </visitorPermission>
  </div>
</template>

<script>
  
import Report from './index.vue';
  export default {
        components: {
        Report
    },
    data() {
      return {
      
      };
    },
    watch: {

    },
    created() {
     
    },
    computed: {
    },
    mounted() {
     
    },
    methods: {

    },
  };
  </script>

<style>
  .report-container{
    padding: 15px;
  }
</style>
  